import { Product } from 'src/api/@generated/backend';

import { selectProduct } from 'src/state/order/order-slice';
import { AppDispatch } from 'src/state/types';

export const selectProductActionCreator = (product: Product) => (dispatch: AppDispatch) => {
  dispatch(selectProduct(product));
};
